import React from "react";

import { Container as StyledContainer } from "./styles";

const Wrapper = props => {
  return <StyledContainer {...props} />;
};

export default Wrapper;
